/**
 * @brief   Shared PopupsModule zur Freigabe der Popup-Komponenten.
 * @details Um eine Popup-Komponente in Feature Modulen verwenden zu können,
 *          wird dieses Shared Module eingebunden.
 *
 *          // Shared Modules einbinden
 *          import {PopupsModule} from '../../shared/popups/popups.module';
 * @author  Massimo Feth <m.feth@pharmakon.software>
 */

// Angular-Module
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// Angular-Material
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
// Für Übersetzung benötigte Module
import {TranslateModule} from '@ngx-translate/core';
// PDF-Viewer für die Dokumenten-Vorschau
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
// Komponenten dieses Shared Modules
import {PopupConfirmationComponent} from './popup-confirmation/popup-confirmation.component';
import {PopupDocumentPreviewComponent} from './popup-document-preview/popup-document-preview.component';
import {PopupFormularContactFilterComponent} from './popup-formular-contact-filter/popup-formular-contact-filter.component';
import {PopupFormularComponent} from './popup-formular/popup-formular.component';
import {PopupLoadingComponent} from './popup-loading/popup-loading.component';
import {PopupMessageComponent} from './popup-message/popup-message.component';
import {PopupProgressToastComponent} from './popup-progress-toast/popup-progress-toast.component';
import {PopupSchedulingComponent} from './popup-scheduling/popup-scheduling.component';
import {PopupSelectEmployeesComponent} from './popup-select-employees/popup-select-employees.component';
import {PopupSignatureComponent} from './popup-signature/popup-signature.component';
import {PopupDuplicateOrderComponent} from './popup-duplicate-order/popup-duplicate-order.component';
import {PopupImportComponent} from './popup-import/popup-import.component';
// Shared Modules einbinden
import {GridModule} from '@shared/grid/grid.module';
import {InputModule} from '@shared/input/input.module';
import {MatDividerModule} from '@angular/material/divider';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        GridModule,
        InputModule,
        TranslateModule,
        MatDividerModule,
        NgxExtendedPdfViewerModule,
        FontAwesomeModule,
    ],
    declarations: [
        PopupConfirmationComponent,
        PopupDocumentPreviewComponent,
        PopupFormularContactFilterComponent,
        PopupLoadingComponent,
        PopupMessageComponent,
        PopupProgressToastComponent,
        PopupSelectEmployeesComponent,
        PopupSchedulingComponent,
        PopupFormularComponent,
        PopupSignatureComponent,
        PopupDuplicateOrderComponent,
        PopupImportComponent,
    ],
    // Komponenten freigeben
    exports: [
        PopupConfirmationComponent,
        PopupDocumentPreviewComponent,
        PopupDuplicateOrderComponent,
        PopupFormularContactFilterComponent,
        PopupLoadingComponent,
        PopupMessageComponent,
        PopupProgressToastComponent,
        PopupSelectEmployeesComponent,
        PopupFormularComponent,
        PopupImportComponent,
        TranslateModule,
    ],
    providers: [{
        provide: MAT_DIALOG_DEFAULT_OPTIONS,
        useValue: {
            hasBackdrop: true,
            autoFocus: false,
        },
    }],
})
export class PopupsModule {}
